import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootStateType } from '@/core/store/store';

const initialState: { selectedYear: null | number } = {
  selectedYear: null,
};
const DASHBOARD_STORE_KEY = 'dashboard';

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setSeletedYear(state, action: PayloadAction<number>) {
      state.selectedYear = action.payload;
    },
  },
});

const selectSchoolYearFromStore = (state: RootStateType) => state.dashboard.selectedYear;

export const { setSeletedYear } = dashboardSlice.actions;
export default dashboardSlice.reducer;
export { DASHBOARD_STORE_KEY, selectSchoolYearFromStore };
